import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/authentication.service';
import DatalabelsPlugin from 'chartjs-plugin-datalabels';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { AppointmentService } from 'src/app/services/appointment.service';
import { ChartDataset, ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { PaymentService } from 'src/app/services/payment.service';
import { elementAt, forkJoin } from 'rxjs';

@Component({
  selector: 'app-dashboard-v2',
  templateUrl: './dashboard-v2.component.html',
  styleUrls: ['./dashboard-v2.component.scss']
})
export class DashboardV2Component implements OnInit {
  public pieChartType: ChartType = 'pie';
  public pieChartPlugins = [DatalabelsPlugin];
  backgroundNotSubmit: any = []
  followUps: any = [];
  followUpsNew: any = [];
  completed: any = []
  fullUserName!: string;
  totalAppts: any;
  ongoingAppts: any;
  show: boolean = false
  months!: any
  locationAppt: any = []
  appointments: any = [];
  followUpAppointments: any = [];
  followUpAppointmentsToBeSchedule: any = [];
  appointmentsv2: any = [];
  followUP: any = [];
  paymentList: any = [];
  scheduleFollowUp: any = [];
  todaysAppts: any;

  constructor(
    private appointmentService: AppointmentService,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService,
    private paymentService: PaymentService,
  ) {
    this.fullUserName = '' + this.authService.getUserFullName();
  }

  // Pie

  public apptPieChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      datalabels: {
        color: '#fff',
        formatter: (value, ctx) => {
          if (ctx.chart.data.labels) {
            return ctx.chart.data.labels[ctx.dataIndex];
          }
        },
      },
    },
  };

  public paymentsPieChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      datalabels: {
        color: '#fff',
        formatter: (value, ctx) => {
          if (ctx.chart.data.labels) {
            return ctx.chart.data.labels[ctx.dataIndex];
          }
        },
      },
    },
  };
  public apptPieChartData!: ChartData
  public paymentsPieChartData!: ChartData
  barChartData!: ChartData

  userRole: any;
  ngOnInit(): void {
    this.spinner.hide();
    jQuery("body").removeClass("timeline-event-created");
    jQuery('.modal-backdrop.fade.show').remove();

    this.show = false
    this.spinner.show();
    this.userRole = this.authService.getUserType();
    let diagId = null;
    if (this.userRole == "DIAGNOSTIC") {
      diagId = this.authService.getUserId()
    } else if (this.userRole == "SUPERADMIN") {
      diagId = null;
    };
    this.followUps = [];
    this.followUpsNew = [];
    this.scheduleFollowUp = [];
    this.backgroundNotSubmit = [];

    if (this.userRole == "SUPERADMIN") {

      forkJoin({
        requestOne: this.appointmentService.getDashboardDetailsV2(diagId),
        // requestTwo: this.appointmentService.getAppointments(null, null, "ALL", null, null, null),
        // followUP:  this.appointmentService.getFollowUp(null, null, "ALL", null, null, null),
        requestThree: this.paymentService.getPaymentDetailsV2(null, null, null),
      }).subscribe(({ requestOne, requestThree }) => {
        this.locationAppt = requestOne.data
        // this.totalAppts = requestOne.data.totalAppointments;
        this.ongoingAppts = requestOne.data.ongoingAppointments;
        this.todaysAppts = requestOne.data.todaysAppointments;        
        let currYear = new Date().getFullYear();
        this.months = requestOne.data[currYear]
        this.barChartData = {
          labels: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          datasets: [
            {
              data: this.months,
              label: 'Appointments',
              backgroundColor: ['#8c5896'],
              hoverBackgroundColor: ['#c4abc9'],

            },
          ]
        };
        this.apptPieChartData = {
          labels: requestOne.data.years,
          datasets: [
            {
              data: requestOne.data.yearsData,
              backgroundColor: ['#8c5896', '#80a254', '#a2a9ae'],
              hoverBackgroundColor: ['#582c60', '#698a3e', '#c7cdd2'],
              hoverBorderColor: ['transparent', 'transparent', 'transparent'],

            },
          ],
        };
        this.paymentsPieChartData = {
          labels: ['Total', 'Received', 'Pending'],
          datasets: [
            {
              data: [requestOne.data.totalPayment, requestOne.data.totalReceived, requestOne.data.totalremaing],
              backgroundColor: ['#8c5896', '#80a254', '#a2a9ae'],
              hoverBackgroundColor: ['#582c60', '#698a3e', '#c7cdd2'],
              hoverBorderColor: ['transparent', 'transparent', 'transparent'],

            },
          ],
        };

        // console.log("Payment List Data: ", this.paymentList);
        if (typeof requestThree.data != 'undefined' && requestThree.data) {
          requestThree.data.forEach((element: any) => {
            if (element.appointmentstatus == "ASSESMENT" && element.message == "") {
              if (this.paymentList.length < 30)
                this.paymentList.unshift(element)
            }
          });
        }
        console.log(this.paymentList);
        this.show = true
        this.spinner.hide();
      },
        err => {
          // console.error("Error fetching data: ", err);qq
          this.spinner.hide();
        }
      );

    }else{// For Admin and others

      forkJoin({
        requestOne: this.appointmentService.getDashboardDetailsV2(diagId),
        //requestTwo: this.appointmentService.getAppointments(null, null, "ALL", null, null, null),
        // followUP:  this.appointmentService.getFollowUp(null, null, "ALL", null, null, null),
        requestThree: this.paymentService.getPaymentDetailsV2(null, null, null),

        requestFollowUp:this.appointmentService.getAppointmentsV2(null, null, "ALL", null, null, null,'First_followup'),

        requestAppointment:this.appointmentService.getAppointmentsV2(null, null, "ALL", null, null, null,'Appointment'),
        requestAppointmentFollowToBeSchedule:this.appointmentService.getFollowupAppointmentsToBeSchedule(null, null, null, null, null),
      }).subscribe(({ requestOne, requestThree,requestFollowUp,requestAppointment,requestAppointmentFollowToBeSchedule }) => {
        this.locationAppt = requestOne.data
        // this.totalAppts = requestOne.data.totalAppointments;
        this.ongoingAppts = requestOne.data.ongoingAppointments;
        this.todaysAppts = requestOne.data.todaysAppointments;
        //  this.followUP=followUP.data;
        let currYear = new Date().getFullYear();

        this.months = requestOne.data[currYear]
        this.barChartData = {
          labels: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          datasets: [
            {
              data: this.months,
              label: 'Appointments',
              backgroundColor: ['#8c5896'],
              hoverBackgroundColor: ['#c4abc9'],

            },
          ]
        };
        this.apptPieChartData = {
          labels: requestOne.data.years,
          datasets: [
            {
              data: requestOne.data.yearsData,
              backgroundColor: ['#8c5896', '#80a254', '#a2a9ae'],
              hoverBackgroundColor: ['#582c60', '#698a3e', '#c7cdd2'],
              hoverBorderColor: ['transparent', 'transparent', 'transparent'],

            },
          ],
        };
        this.paymentsPieChartData = {
          labels: ['Total', 'Received', 'Pending'],
          datasets: [
            {
              data: [requestOne.data.totalPayment, requestOne.data.totalReceived, requestOne.data.totalremaing],
              backgroundColor: ['#8c5896', '#80a254', '#a2a9ae'],
              hoverBackgroundColor: ['#582c60', '#698a3e', '#c7cdd2'],
              hoverBorderColor: ['transparent', 'transparent', 'transparent'],

            },
          ],
        };

        this.followUpAppointments=requestFollowUp.data;
        if (typeof this.followUpAppointments != 'undefined' && this.followUpAppointments) {
          this.followUpAppointments.slice().forEach((el: any) => {

            if (el.status == "FOLLOWUP" && el.status != "CANCEL") {
              //if (this.followUps.length < 4)
              this.followUps.push(el)
            }             
          });// end of for each loop


          if (this.followUps.length > 0) {
            this.followUps = this.followUps.sort((a: any, b: any) => (new Date(a.appointmentDate) <= new Date(b.appointmentDate) ? -1 : 1));
            // let indexCount:number = 2; 
            this.followUps.forEach((a: any) => {
              if (new Date(a.start) >= new Date()) {
                this.followUpsNew.push(a);
                // indexCount++;
              }
            });
            this.followUpsNew = this.followUpsNew.slice(0, 30);
          }
        }

        //Get Appointments data
        this.appointmentsv2=requestAppointment.data;
        if (typeof this.appointmentsv2 != 'undefined' && this.appointmentsv2) {
          this.appointmentsv2.slice().forEach((el: any) => {            
            if (!el.statusTracking.includes("BACKGROUNDFORMSUBMIT") && el.status != "CANCEL" && el.status != "ASSESMENT" && el.status != "COMPLETE") {
              if (this.backgroundNotSubmit.length < 50)
                this.backgroundNotSubmit.push(el)
            }
            
            
          });// end of for each loop
        }

        //Followup to be schedule 
        this.followUpAppointmentsToBeSchedule=requestAppointmentFollowToBeSchedule.data
        if (typeof this.followUpAppointmentsToBeSchedule != 'undefined' && this.followUpAppointmentsToBeSchedule) {
          this.followUpAppointmentsToBeSchedule.slice().forEach((el: any) => {
            
            if (el.status != "FOLLOWUP" && el.status != "CANCEL" && el.status != "ASSESMENT" && el.status != "COMPLETE") {
              if (this.scheduleFollowUp.length < 30)
                this.scheduleFollowUp.push(el)
            } 
          });// end of for each loop
        }

      

        //sort the data as per date
        if (this.followUpsNew.length > 0) {
          this.followUpsNew = this.followUpsNew.sort((a: any, b: any) => (new Date(a.appointmentDate) <= new Date(b.appointmentDate) ? -1 : 1));
        }
        if (this.scheduleFollowUp.length > 0) {
          this.scheduleFollowUp = this.scheduleFollowUp.sort((a: any, b: any) => (new Date(a.appointmentDate) <= new Date(b.appointmentDate) ? -1 : 1));
        }
        if (this.backgroundNotSubmit.length > 0) {
          this.backgroundNotSubmit = this.backgroundNotSubmit.sort((a: any, b: any) => (new Date(a.appointmentDate) <= new Date(b.appointmentDate) ? -1 : 1));
        }



        // payment data
        if (typeof requestThree.data != 'undefined' && requestThree.data) {
          requestThree.data.forEach((element: any) => {
            if (element.appointmentstatus == "ASSESMENT" && element.message == "") {
              if (this.paymentList.length < 30)
                this.paymentList.unshift(element)
            }
          });
        }
       //console.log(this.paymentList);
        this.show = true
        this.spinner.hide();
      },
        err => {
          // console.error("Error fetching data: ", err);qq
          this.spinner.hide();
        }
      );

    }



  }

  // Bar Chart

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  public barChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      x: {},
      y: {
        min: 0
      }
    },
    plugins: {
      legend: {
        display: true,
      },
      datalabels: {
        anchor: 'end',
        align: 'end'
      }
    }
  };
  public barChartType: ChartType = 'bar';
  public barChartPlugins = [
    DatalabelsPlugin
  ];

  getDateStart(e: any) {
    return e.substring(0, 9);
  }

  // events
  chartClicked(e: any): void {
    if (e.active.length > 0) {
      const chart = e.active[0].chart;

    }




  }
}



